export default __webpack_public_path__ + "static/media/man-working.fa3827d2.svg";